import type { FC } from 'react';
import { useCallback, useContext, useState, useId } from 'react';
import { useTranslation } from 'react-i18next';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import ListItemRadioButton from '@wix/da-ds/pkg/List/ListItem/dsPresets/ListItemRadioButton';
import DesktopBatchActionWrapper from '../DesktopBatchActionWrapper';
import MobileBatchActionWrapper from '../MobileBatchActionWrapper';
import { BatchActionProps } from '../types';

export interface Props extends BatchActionProps {
  batchEditComments: (allowComments: boolean) => void;
}

const CommentsBatchEdit: FC<Props> = ({ selectionArea, batchEditComments }) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);
  const allowInputId = useId();
  const disableInputId = useId();
  const [value, setValue] = useState(true);

  const handleSave = useCallback(() => {
    batchEditComments(value);
  }, [batchEditComments, value]);
  const handleChange = useCallback(
    newValue => {
      setValue(newValue);
    },
    [setValue]
  );

  const form = (
    <div>
      <ListItemRadioButton
        compact
        id={allowInputId}
        onChange={() => handleChange(true)}
        label={t('studio.batchActions.form.edit_comments.allow')}
        name="allowComments"
        value="yes"
        checked={value === true}
      />
      <ListItemRadioButton
        compact
        id={disableInputId}
        onChange={() => handleChange(false)}
        label={t('studio.batchActions.form.edit_comments.disable')}
        name="allowComments"
        value="no"
        checked={value === false}
      />
    </div>
  );

  if (isMobile) {
    return (
      <MobileBatchActionWrapper onSave={handleSave} restrictSave="non_core_multiple">
        {form}
      </MobileBatchActionWrapper>
    );
  }
  return (
    <DesktopBatchActionWrapper
      selectionArea={selectionArea}
      onSave={handleSave}
      restrictSave="non_core_multiple"
    >
      {form}
    </DesktopBatchActionWrapper>
  );
};
CommentsBatchEdit.displayName = 'CommentsBatchEdit';

export default CommentsBatchEdit;
